// extracted by mini-css-extract-plugin
module.exports = {"info_container":"Info_info_container__1U5X1","info_sub_container":"Info_info_sub_container__1cx95","info_heading":"Info_info_heading__1ZFJW","info_text":"Info_info_text__37WrK"};